// Workstream: growth. A looping, CSS-only demo of one round: cards are dealt, the judge picks one,
// and it drops into the blank. With reduced motion, the finished round shows as a still picture.

const ANSWERS = ['A blurry photo of dal', 'Good morning roses \u{1F339}', 'Sharma ji ka beta'];
const WINNER = 1;

export function Demo() {
  return (
    <div
      className="demo"
      role="img"
      aria-label={`A round of CompleteMasti: the prompt "Mummy's WhatsApp status today: ___." Three answer cards are played, and "${ANSWERS[WINNER]}" wins.`}
    >
      <div className="demo-captions" aria-hidden="true">
        <span className="demo-cap demo-cap-1">1. Everyone plays a card</span>
        <span className="demo-cap demo-cap-2">2. The judge picks the funniest</span>
        <span className="demo-cap demo-cap-3">3. Pinky gets the point</span>
      </div>
      <div className="card prompt demo-prompt" aria-hidden="true">
        <span>
          Mummy&apos;s WhatsApp status today:{' '}
          <span className="demo-slot">
            <span className="blank demo-blank" />
            <span className="fill demo-fill">{ANSWERS[WINNER]}</span>
          </span>
          .
        </span>
        <span className="brandmark">CompleteMasti</span>
      </div>
      <div className="demo-hand" aria-hidden="true">
        {ANSWERS.map((a, i) => (
          <div key={a} className={`demo-deal demo-deal-${i + 1}`}>
            <div className={`card answer ${i === WINNER ? 'demo-winner' : ''}`}>
              {a}
              {i === WINNER && <span className="demo-crown">{'\u{1F451}'} Pinky</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
